import { styled } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

/* be careful about modifying the style of this file,
  as it is consistent with the style of the declarations page.
  src/components/DeclarationForm/DeclarationFormFinalStep/FinalStepOverview/Overview/styles.ts
*/

export const StyledProductsContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
  }),
);

export const StyledProductContainer = styled('div')(
  ({
    theme,
    backgroundColor,
    fontColor,
    isItalicStyleText,
  }: {
    theme: ICustomTheme;
    backgroundColor?: string;
    fontColor?: string;
    isItalicStyleText?: boolean;
  }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1, 0, 1, 1),
    paddingRight: 48,
    borderBottom: backgroundColor
      ? 'none'
      : `1px solid ${theme.colors.grey.light3}`,
    backgroundColor: backgroundColor || theme.colors.white,
    color: fontColor || theme.colors.grey.dark,
    fontStyle: isItalicStyleText ? 'italic' : 'normal',
  }),
);

export const StyledLeftContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    width: '40%',
    minWidth: '40%',
    maxWidth: '40%',
  }),
);

export const StyledProductInfo = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingLeft: theme.spacing(2),
  }),
);

export const StyledDataContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'right',
    flexGrow: 1,
  }),
);

export const StyledDataItem = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    paddingRight: theme.spacing(3),
    width: '30%',
    textAlign: 'right',
  }),
);

export const StyledPagination = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  }),
);

export const StyledUnitToDisplay = styled('span')(
  ({ theme }: { theme: ICustomTheme }) => ({
    marginLeft: theme.spacing(1),
  }),
);
